import styled from "styled-components"
import theme from "styles/theme-main"
import { media } from "../../utils/utils"

export const Wrapper = styled.div`
  width: 412px;
  max-width: 85%;
`

export const FormWrapper = styled.div`
  padding: 38px 0;
`

export const FormHeader = styled.h2`
  font-size: 21px;
  line-height: 28px;
  color: #323c44;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 19px;
`

export const FormRow = styled.div`
  padding: ${props => (props.last ? 0 : "0 0 40px 0")};
`

export const FormFooter = styled.div`
  ${media.md`
    text-align: center;
    
    button:first-child {
      margin:0;
    }
    
    button:last-child {
      margin-top:40px;
    }
  `};
`

export const FormRowFooter = styled.div`
  padding: 15px 0;

  span {
    font-size: 14px;
    line-height: 1.3;
  }
`

export const TwoUpWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${props =>
    props.showRegister ? "space-between" : "center"};
  align-items: stretch;
  margin-top: 30px;

  @media (max-width: 800px) {
    flex-direction: column-reverse;
    align-items: center;
    max-width: 100%;
  }
`

export const TitleWrapper = styled.div`
  border-bottom: 1px solid ${theme.colors.border};
  margin-top: 31px;
  color: ${theme.colors.textSecondaryDark};
  width: 100%;
  max-width: 100%;

  @media (max-width: 800px) {
    margin-top: 7px;
  }
`

export const TitleText = styled.h1`
  text-align: center;
  letter-spacing: 6px;
  font-size: 30px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  text-transform: uppercase;
  padding-bottom: 20px;
  max-width: 90%;
  margin: 0 auto 0 auto;

  @media (max-width: 800px) {
    font-size: 24px;
    text-align: center;
  }
`

export const Divider = styled.div`
  width: 1px;
  border-right: 1px solid #c4cace;

  @media (max-width: 800px) {
    width: 70%;
    border-top: 1px solid #c4cace;
    margin: 20px 0 35px 0;
  }
`

export const DataRow = styled.div`
  height: 115px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid ${theme.colors.border};
  margin-bottom: 34px;
  max-width: 100vw;

  @media (max-width: 800px) {
    flex-direction: column;
    height: 200px;
  }
`

export const DataItem = styled.div`
  font-size: 16px;
  font-weight: bold;
  padding: 0 28px 0 28px;
  border-right: 1px solid ${theme.colors.border};
  color: ${theme.colors.textPrimary};
  max-width: 32%;

  @media (max-width: 800px) {
    width: 90%;
    max-width: 100%;
    height: 32%;
    border-right: none;
    border-bottom: 1px solid ${theme.colors.border};
    display: flex;
    justify-content: center;
    align-items: center;

    &:last-of-type {
      border: 0;
    }
  }

  @media (min-width: 800px) {
    &:first-of-type {
      padding-left: 0;
    }
    &:last-of-type {
      border: 0;
      max-width: max-content;
    }
  }
`

export const Overview = styled.div`
  font-family: Europa;
  font-size: 16px;
  font-weight: normal;
  line-height: 1.5;
  letter-spacing: 0.2px;
  color: ${theme.colors.textPrimary};
  margin: 40px 0 40px 0;
  @media (max-width: 800px) {
    padding: 18px;
  }
`

export const OverviewButtonContainer = styled.div`
  margin-top: 40px;
`

export const DownloadItem = styled.div`
  font-family: Europa;
  font-size: 16px;
  font-weight: normal;
  line-height: 1.5;
  letter-spacing: 0.2px;
  color: ${theme.colors.textPrimary};

  > a {
    font-family: Europa;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: 0.2px;
    color: ${theme.colors.textPrimary};
  }

  > a:hover {
    text-decoration: none;
  }
`

export const DeadlineWrapper = styled.p`
  margin: 18px 0 0 0;
  line-height: 25px;
`
